module.exports = __webpack_public_path__ + "7c4bc0f4fe2856aa5fbd9c45433b2812.MP3";